/**
 * Shared localStorage key namespace for the widget bundles.
 *
 * Both `storage.ts` (widget bundle) and `loader.ts` (loader bundle) import
 * from here so the prefix lives in one place. See
 * `apps/helpdesk/docs/features/live-chat-widget-conversation-cache.md` §8 for
 * the rationale: the widget runs on third-party origins (acme.com, …) where
 * localStorage is shared with the customer's own JS, analytics SDKs, and
 * other embedded chat / feedback widgets. Branding the prefix with
 * `airclou:` eliminates accidental collisions and matches how peer embeds
 * namespace their state (Intercom: `intercom-…`, Drift: `drift-…`).
 */

const STORAGE_PREFIX = 'airclou:helpdesk-widget';

export function scoped(tenantId: string, workspaceId: string, key: string): string {
  return `${STORAGE_PREFIX}:${tenantId}:${workspaceId}:${key}`;
}
